module.exports = __webpack_public_path__ + "img/lock-03.b945fa10.svg";